import React from 'react';
import { InformationCircleIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';

const MemoryRetentionIndicator = ({ lastAccessed, calculateOpacity }) => {
  const { t } = useTranslation();
  
  if (!lastAccessed) return null;
  
  const retentionPercentage = Math.round(calculateOpacity(lastAccessed) * 100);
  
  return (
    <div className="absolute top-2 right-2 group">
      <InformationCircleIcon 
        className="h-4 w-4 text-blue-400/70 info-icon cursor-help" 
      />
      <div className="hidden group-hover:block absolute right-0 w-64 p-2 bg-gray-900 text-white text-xs rounded shadow-lg z-10">
        <p className="font-bold mb-1">{t('memory.masteryLevel')}</p>
        <div className="w-full h-2 bg-gray-700 rounded-full mb-1 overflow-hidden">
          <div 
            className="h-full bg-gradient-to-r from-green-600/80 to-green-500/80" 
            style={{ width: `${retentionPercentage}%` }}
          ></div>
        </div>
        <p>{t('memory.basedOnCurve', { percentage: retentionPercentage })}</p>
        <p className="mt-1">{t('memory.lastAccessed', { time: new Date(lastAccessed).toLocaleString() })}</p>
        <p className="mt-1 text-blue-300">{t('memory.clickToRefresh')}</p>
      </div>
    </div>
  );
};

export default MemoryRetentionIndicator;
